import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import "react";
const GosuslugiIconLogo = ()=>{
    const $ = c(6);
    let t0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ jsx("path", {
            d: "M10 0.5C15.2467 0.5 19.5 4.7533 19.5 10C19.5 15.2467 15.2467 19.5 10 19.5C4.7533 19.5 0.5 15.2467 0.5 10C0.5 4.7533 4.7533 0.5 10 0.5Z",
            fill: "white"
        });
        t1 = /*#__PURE__*/ jsx("path", {
            d: "M10 0.5C15.2467 0.5 19.5 4.7533 19.5 10C19.5 15.2467 15.2467 19.5 10 19.5C4.7533 19.5 0.5 15.2467 0.5 10C0.5 4.7533 4.7533 0.5 10 0.5Z",
            stroke: "#E2E6EB"
        });
        t2 = /*#__PURE__*/ jsx("path", {
            d: "M16.2254 7.64051C16.1701 6.9179 15.6176 5.99149 15.0651 5.54681C14.4438 5.09173 13.7982 4.67113 13.1313 4.28689C12.4694 3.89221 11.787 3.53349 11.087 3.21225C10.7131 3.05879 10.3121 2.98315 9.90833 2.98991C9.50439 2.98137 9.10307 3.05707 8.72964 3.21225C8.02974 3.53371 7.34735 3.89244 6.68536 4.28689C5.61717 4.93538 4.75157 5.54681 4.75157 5.54681C4.41155 5.83309 4.13322 6.18087 3.92866 6.56865C3.77074 6.86803 4.01298 7.19576 4.35147 7.19576C4.72745 7.19576 5.06119 6.97691 5.30397 6.68982C5.40777 6.56708 5.52251 6.45276 5.64731 6.3484C5.64731 6.3484 6.36202 5.84703 7.244 5.31526C7.79059 4.99181 8.35403 4.69766 8.93192 4.43406C9.24025 4.30682 9.57162 4.24474 9.90514 4.25174C10.2385 4.2462 10.5696 4.30822 10.8784 4.43406C11.4563 4.69748 12.0198 4.99163 12.5663 5.31526C13.1169 5.63034 13.65 5.97524 14.163 6.3484C14.6192 6.71304 15.0754 7.4727 15.121 8.06523C15.121 8.06523 15.2274 8.94644 15.2426 9.99021C15.2417 10.6348 15.2062 11.2789 15.1362 11.9197C15.0301 12.5907 14.6844 13.2006 14.163 13.6366C14.163 13.6366 13.4483 14.1531 12.5663 14.6849C12.0197 15.0084 11.4563 15.3025 10.8784 15.5661C10.57 15.6934 10.2387 15.7554 9.90514 15.7484C9.57205 15.7554 9.241 15.695 8.93192 15.5707C8.35394 15.3073 7.79049 15.0131 7.244 14.6895C6.36202 14.1729 5.64731 13.6411 5.64731 13.6411C5.5342 13.5507 5.42108 13.436 5.314 13.3056C5.07722 13.0173 4.74463 12.8044 4.37152 12.8044C4.0256 12.8044 3.78484 13.1412 3.95231 13.4439C4.17289 13.8425 4.46223 14.2075 4.75157 14.4404C4.75157 14.4404 5.61717 15.0889 6.68536 15.7188C7.34723 16.1135 8.02963 16.4722 8.72964 16.7935C9.10397 16.945 9.50492 17.0188 9.90833 17.0103C10.3123 17.0188 10.7136 16.9431 11.087 16.7879C11.7869 16.4665 12.4693 16.1077 13.1313 15.7133C14.1995 15.0648 15.0651 14.4348 15.0651 14.4348C15.6966 13.9032 16.1153 13.1594 16.2438 12.3411C16.3285 11.5597 16.3716 10.7742 16.3727 9.98804C16.3543 8.71515 16.2254 7.64051 16.2254 7.64051Z",
            fill: "url(#paint0_linear_esia_icon)"
        });
        t3 = /*#__PURE__*/ jsx("path", {
            d: "M3.62744 8.45817C3.62744 8.30329 3.753 8.17773 3.90788 8.17773H8.25462C8.4095 8.17773 8.53506 8.30329 8.53506 8.45817V9.29947C8.53506 9.45435 8.4095 9.5799 8.25462 9.5799H3.62744V8.45817Z",
            fill: "#0066B3"
        });
        t4 = /*#__PURE__*/ jsx("path", {
            d: "M3.62744 10.4219H12.4612C12.616 10.4219 12.7416 10.5474 12.7416 10.7023V11.5436C12.7416 11.6985 12.616 11.824 12.4612 11.824H3.90788C3.753 11.824 3.62744 11.6985 3.62744 11.5436V10.4219Z",
            fill: "#EE2F53"
        });
        $[0] = t0;
        $[1] = t1;
        $[2] = t2;
        $[3] = t3;
        $[4] = t4;
    } else {
        t0 = $[0];
        t1 = $[1];
        t2 = $[2];
        t3 = $[3];
        t4 = $[4];
    }
    let t5;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ jsxs("svg", {
            width: "20",
            height: "20",
            viewBox: "0 0 20 20",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                t0,
                t1,
                t2,
                t3,
                t4,
                /*#__PURE__*/ jsx("defs", {
                    children: /*#__PURE__*/ jsxs("linearGradient", {
                        id: "paint0_linear_esia_icon",
                        x1: "10.0225",
                        y1: "2.98926",
                        x2: "10.0225",
                        y2: "17.0109",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ jsx("stop", {
                                stopColor: "#0066B3"
                            }),
                            /*#__PURE__*/ jsx("stop", {
                                offset: "0.354167",
                                stopColor: "#0066B3"
                            }),
                            /*#__PURE__*/ jsx("stop", {
                                offset: "0.6875",
                                stopColor: "#EE2F53"
                            }),
                            /*#__PURE__*/ jsx("stop", {
                                offset: "1",
                                stopColor: "#EE2F53"
                            })
                        ]
                    })
                })
            ]
        });
        $[5] = t5;
    } else t5 = $[5];
    return t5;
};
export { GosuslugiIconLogo };
